import { render, staticRenderFns } from "./seriesCollection.vue?vue&type=template&id=a981424c&scoped=true"
import script from "./seriesCollection.vue?vue&type=script&lang=js"
export * from "./seriesCollection.vue?vue&type=script&lang=js"
import style0 from "./seriesCollection.vue?vue&type=style&index=0&id=a981424c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a981424c",
  null
  
)

export default component.exports